import React from "react";
import { Box, Typography } from "@mui/material";
import { formatDate } from "../../../../../../utils/utils";

function Query({ query }) {
  const { content_object, created_at } = query;

  return (
    <Box>
      <Typography
        fontWeight={500}
        sx={{ whiteSpace: "pre-wrap" }}>
        {content_object["text"]}
      </Typography>
      <Typography variant="caption" color={"textSecondary"}>
        {formatDate(created_at)}
      </Typography>
    </Box>
  );
}

export default Query;
